import { MouseEvent } from 'react';

import { SkipLink } from 'approot/shared/layout/layout-skip-links.style';

export const ACTIVITY_BUILDER_SLIDE = 'skipSlide';
export const ACTIVITY_BUILDER_SETTINGS = 'skipSettings';

const ActivityBuilderPresentSkipLinks = ({
  showSlideSkip,
}: {
  showSlideSkip: boolean;
}) => {
  const handleClick = (e: MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const el = document.getElementById(id);
    el?.focus();
  };

  return (
    <>
      {showSlideSkip && (
        <SkipLink
          href={`#${ACTIVITY_BUILDER_SLIDE}`}
          onClick={e => handleClick(e, ACTIVITY_BUILDER_SLIDE)}
        >
          <span>Skip to slide</span>
        </SkipLink>
      )}
      <SkipLink
        href={`#${ACTIVITY_BUILDER_SETTINGS}`}
        onClick={e => handleClick(e, ACTIVITY_BUILDER_SETTINGS)}
      >
        <span>Skip to menu</span>
      </SkipLink>
    </>
  );
};

export default ActivityBuilderPresentSkipLinks;
